import useDialog from 'components/ConfirmDialog/useDialog';
import CustomButton from 'components/CustomInput/Button';
import TextHeader from 'components/CustomText/TextHeader';
import useApplicationBarAction from 'hooks/useApplicationBarAction';
import OptionConfirmDialog from 'components/Application/InitialApplication/OptionConfirmDialog/index';
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components/macro';
import { isFormChanged, permissionChecking } from 'utility/general';
import {
    APPLICANT,
    DRAFT,
    RETURNED,
    RETURN_FROM_IRB,
    KEY_PATHNAME,
    TAB_COMMENT,
    TAB_REVIEWER_COMMENT,
    TAB_CONSOLIDATION,
    TAB_MEETINGARRANGE,
} from 'utility/lookup';
import { getFolderDisplayPath } from 'utility/general';
import { getItem } from 'storage';
import { APP_FORM_STATUS_NOT_MATCH, DISCARD_CONFIRM } from 'utility/frontendMessage';
import api from 'api/call';
import { setGlobal } from 'store/global/reducer';
import { isArray } from 'lodash';
const SLayout = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* padding: 10px 0; */
    width: 100%;
`;

const SButtonLayout = styled.div`
    margin-right: 20px;
`;

const ApplicationActionBar = ({
    currentTab,
    siteInfoId,
    applicationFormId,
    backToStudyInfo = () => null,
    documentType,
}) => {
    const applicationDetail = useSelector((state) => state.applicationDetail[applicationFormId ?? 'undefined']);
    const applicationFolder = useSelector((state) => state.application.folder || 'all');
    const statusId = applicationDetail?.status?.statusId ?? -1;
    const userRole = useSelector((state) => state.user.role);
    const [isButtonLoading, setButtonLoading] = useState(false);
    const { filter: applicationButtons } = useApplicationBarAction({
        applicationDetail,
        siteInfoId,
        tabType: currentTab.type,
        fromId: applicationFormId,
        statusId,
        currentTabKey: currentTab.key,
        documentType,
    });
    const history = useHistory();
    const showConfirm = useDialog();

    const dispatch = useDispatch();

    const checkApplicationStatus = async () => {
        const res = await api.application.checkApplicationStatus(applicationFormId);
        return res.data.result;
    };

    return (
        <SLayout>
            <OptionConfirmDialog />
            <div style={{ display: 'flex' }}>
                {![TAB_COMMENT, TAB_REVIEWER_COMMENT, TAB_MEETINGARRANGE].includes(currentTab.type) &&
                    applicationDetail &&
                    applicationButtons
                        .filter((item) => {
                            // if status is array
                            if (typeof item.status === 'object') {
                                return item.status.includes(statusId);
                            }

                            return item.status === statusId;
                        })
                        .filter((item) => {
                            if (item.condition !== undefined) {
                                return item.condition({ currentTab: currentTab.type });
                            }

                            return true;
                        })
                        .filter((item) => {
                            if (item.showInTab) {
                                if (isArray(item.showInTab)) {
                                    return item.showInTab.includes(currentTab.type);
                                }
                                return currentTab.type === item.showInTab;
                            }
                            return true;
                        })
                        .map((button, index) => {
                            const extraProps = {};

                            if (button.icon) {
                                extraProps.startIcon = button.icon;
                            }

                            return (
                                <SButtonLayout key={`${button.text}-${index}`}>
                                    {button && button.customDialog}
                                    <CustomButton
                                        {...extraProps}
                                        loading={isButtonLoading}
                                        onClick={async () => {
                                            // check status is valid before execute the button action
                                            setButtonLoading(true);

                                            try {
                                                if (!button.disableStatusChecking) {
                                                    if (button.status) {
                                                        let buttonStatus =
                                                            typeof button.status !== 'object'
                                                                ? [button.status]
                                                                : button.status;
                                                        const remoteFormStatusId = await checkApplicationStatus();

                                                        // if remote status updated and not match with the button's status requirement, block the button action.
                                                        if (!buttonStatus.includes(remoteFormStatusId)) {
                                                            setButtonLoading(false);
                                                            return showConfirm({
                                                                description: APP_FORM_STATUS_NOT_MATCH,
                                                                isError: true,
                                                                disableCancelButton: true,
                                                            });
                                                        }
                                                    }
                                                }

                                                button.action({ currentTab: currentTab.type, status: button.status });
                                            } catch (error) {
                                                console.log('101331 ApplicationActionBar.jsx error', button, error);
                                            }

                                            setButtonLoading(false);
                                        }}
                                        disabled={button.isDisabled?.()}
                                        type={button.type}
                                    >
                                        {button.text}
                                    </CustomButton>
                                </SButtonLayout>
                            );
                        })}
                <SButtonLayout>
                    <CustomButton
                        type={'cancel'}
                        onClick={async () => {
                            if (
                                [TAB_COMMENT, TAB_REVIEWER_COMMENT, TAB_CONSOLIDATION, TAB_MEETINGARRANGE].includes(
                                    currentTab.type,
                                )
                            ) {
                                backToStudyInfo();
                            } else {
                                if (statusId === DRAFT || statusId === RETURNED || statusId === RETURN_FROM_IRB) {
                                    if (userRole === APPLICANT) {
                                        const isFormUpdated = await isFormChanged();

                                        let isConfirm = true;

                                        if (isFormUpdated) {
                                            isConfirm = await showConfirm({
                                                description: DISCARD_CONFIRM,
                                            });
                                        }

                                        if (!isConfirm) {
                                            return;
                                        }
                                    }
                                }

                                dispatch(
                                    setGlobal({
                                        isDetailBack: true,
                                    }),
                                );

                                if (getItem(KEY_PATHNAME) === '/search') {
                                    history.push(getItem(KEY_PATHNAME));
                                } else {
                                    const url = getFolderDisplayPath(userRole, statusId);

                                    let extraQuery = '';

                                    if (url !== `/${applicationFolder}`) {
                                        extraQuery = '?page=1';
                                    }

                                    history.push(`/applications${url}${extraQuery}`);
                                }
                            }
                        }}
                    >
                        {[TAB_COMMENT, TAB_REVIEWER_COMMENT, TAB_CONSOLIDATION, TAB_MEETINGARRANGE].includes(
                            currentTab.type,
                        )
                            ? 'Back to study info'
                            : 'Close'}
                    </CustomButton>
                </SButtonLayout>
            </div>
            <TextHeader>
                {!permissionChecking({
                    tabType: currentTab.type,
                    siteInfoId,
                    applicationDetail,
                    isAmendmentCreate: false,
                    isAmendmentEdit: false,
                }) && <div>View Only</div>}
            </TextHeader>
        </SLayout>
    );
};

export default ApplicationActionBar;
